export default {"id":"f2b87c05","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}